import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {routePath, sep} from 'sdv-common';
import {AlarmComponent} from './alarm/alarm.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DetailsComponent} from './details/details.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {HomeComponent} from './home/home.component';
import {MainComponent} from './main/main.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {OoopsComponent} from './ooops/ooops.component';
import {ProfileComponent} from './profile/profile.component';
import {ProjectComponent} from './project/project.component';
import {debugging} from './shared/constants';
import {SignInComponent} from './sign-in/sign-in.component';
import {SignOutComponent} from './sign-out/sign-out.component';
import {SignUpComponent} from './sign-up/sign-up.component';
import {OverviewComponent} from './overview/overview.component';
import {AttendeeComponent} from "./attendee/attendee.component";

const authRoutes = [
  {
    path: routePath.login,
    component: SignInComponent
  },
  {
    path: routePath.registration,
    component: SignUpComponent
  },
  {
    path: routePath.logout,
    component: SignOutComponent
  }
];

const mainRoutes = [
  {
    path: routePath.copyright,
    loadChildren: () => import('./copyright/copyright.module').then(m => m.CopyrightModule)
  },
  {
    path: routePath.cookie,
    loadChildren: () => import('./cookie/cookie.module').then(m => m.CookieModule)
  },
  {
    path: routePath.termsAndConditions,
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: routePath.privacy,
    loadChildren: () => import('./privacy/privacy.module').then(m => m.PrivacyModule)
  },
  {
    path: routePath.disclaimer,
    loadChildren: () => import('./disclaimer/disclaimer.module').then(m => m.DisclaimerModule)
  },
  {
    path: routePath.consent,
    loadChildren: () => import('./consent/consent.module').then(m => m.ConsentModule)
  }
];

const serviceRoutes = [
  {
    path: routePath.notFound,
    component: NotFoundComponent
  },
  {
    path: routePath.accessDenied,
    component: ForbiddenComponent
  },
  {
    path: routePath.internalError,
    component: OoopsComponent
  }
];

const routes: Routes = [
  ...authRoutes,
  {
    pathMatch: 'full',
    path: routePath.root,
    redirectTo: ({queryParams}) => {
      if (Object.keys(queryParams).length === 0) {
        return sep + 'home';
      }
      return sep + 'home?' + new URLSearchParams(queryParams || {}).toString();
    }
  },
  {
    path: routePath.home,
    component: HomeComponent
  },
  {
    path: routePath.root,
    component: MainComponent,
    children: [
      ...mainRoutes,
      ...serviceRoutes,
      {
        path: routePath.root,
        component: OverviewComponent
      },
      {
        path: 'attendees',
        component: AttendeeComponent
      },
      {
        path: 'alarms',
        component: AlarmComponent
      },
      {
        path: 'details',
        component: DetailsComponent
      },
      {
        path: 'projects',
        component: ProjectComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'documentation',
        loadChildren: () => import('./documentation/documentation.module').then(m => m.DocumentationModule)
      },
      {
        path: 'use',
        loadChildren: () => import('./use/use.module').then(m => m.UseModule)
      },
      {
        path: routePath.profile,
        component: ProfileComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot([
      ...routes,
      {
        path: routePath.all,
        redirectTo: sep + routePath.notFound
      }
    ], {
      enableTracing: debugging
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
